import { Order } from "../../../types/order"
import { formatChapelNumbers } from "../../../utils/chapelsFormater"
import { getBorderColorStyle, getTextColorStatusStyle, getTextColorStyle } from "../../../utils/statusStyles"

interface OrderItemProps {
    order: Order
    handleViewOrderDetails: (value: number) => void;
    handleUpdateOrder: (value: number) => void;
}

export default function OrderItem({ order, handleViewOrderDetails, handleUpdateOrder }: OrderItemProps) {
    return (
        <div key={order.orderID} className={`bg-white border cursor-pointer border-t-8 ${getBorderColorStyle(order.orderStatus)} shadow-md rounded-md p-4 hover:shadow-lg transition-all duration-300` }>
            <div className="flex justify-between items-center mb-3 border-b border-orange-100 pb-1">
                <h2 className="text-sm font-semibold text-gray-800 truncate">{order.userName}</h2>
            </div>
            <div className="space-y-1 text-sm text-gray-600">
                <div className="flex justify-between">
                    <span className="font-medium text-gray-700 ">Order ID:</span>
                    <span className='truncate'>{order.orderID}</span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium text-gray-700 ">Chapel:</span>
                    <span className='truncate'>
                        {order?.chapels && formatChapelNumbers(order.chapels)}
                    </span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Status:</span>
                    <span className={`font-medium ${getTextColorStatusStyle(order.orderStatus)}`}>{order.orderStatus}</span>
                </div>
                <div className='w-full flex justify-center space-x-2 h-auto'>
                    <button
                        className={`mt-2 w-full py-1.5 text-[12px] md:text-sm rounded text-black font-medium transition-colors duration-200
                        bg-gray-300`}
                        onClick={() => handleViewOrderDetails(order.orderID)}
                    >
                        View
                    </button>
                    {order.orderStatus !== "Claimed" && order.orderStatus !== "Cancelled" && (
                    <button
                        className="mt-2 w-full text-[12px] md:text-sm rounded text-white py-1.5 font-medium transition-colors duration-200 bg-cbColor"
                        onClick={() => handleUpdateOrder(order.orderID)}
                    >
                        Update
                    </button>
                    )}
                </div>
            </div>
        </div>
    )
}
